module.exports = __webpack_public_path__ + "static/media/hollow_bar_liquidStrip.a36b01e4.svg";